import React from 'react';

import questions from './faqQuestions';

export default function FAQ(){
	return <div className='faqContainer'>
		{
			questions.map(question => <div className='faqItem panel' key={question.question}>
				<h2>{question.question}</h2>
				{question.answer}
			</div>)
		}
	</div>
}